import React, { Component, memo } from 'react';

import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { IaCreators } from '../../../../store/actions/intelligence';
import { BotsCreators } from '../../../../store/actions/bots';
import { UserActions } from '../../../../store/actions/users';

import './Monitore.scss';
import CirclePoint from '../../component/CirclePoint/CirclePoint';
import HelpBalloon from '../../component/HelpBalloon/HelpBalloon';
import Provedores from '../Provedores/Provedores';
import Toggle from '../../../Elements/Toggle';
import iconCheck from '../../../../assets/images/icon_check.svg';
import iconFalta from '../../../../assets/images/icon_falta.svg';
import iconErro from '../../../../assets/images/icon_erro.svg';

class Monitore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monitore: 'status',
    };
  }

  isMonitore = (monitore) => this.setState({ monitore });

  onToggleChanged = () => {
    const { bot, updateBotRequest } = this.props;
    updateBotRequest(bot._id, { iaEnabled: !bot.iaEnabled }, false, true);
  };

  componentDidMount() {
    if (
      this.props.bot.currentTokenIa !== undefined &&
      this.props.bot.currentTokenIa !== ''
    ) {
      this.props.listCurationMessages(this.props.bot._id, 1, '', '');
      this.props.getIaInfo(this.props.bot.currentTokenIa);
      this.props.listIAEntities(this.props.bot.currentTokenIa);
      this.props.listAllSamples(this.props.bot.currentTokenIa, 'intent');
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.bot.currentTokenIa !== this.props.bot.currentTokenIa) {
      if (
        this.props.bot.currentTokenIa !== undefined &&
        this.props.bot.currentTokenIa !== ''
      ) {
        this.props.listCurationMessages(this.props.bot._id, 1, '', '');
        this.props.getIaInfo(this.props.bot.currentTokenIa);
        this.props.listIAEntities(this.props.bot.currentTokenIa);
        this.props.listAllSamples(this.props.bot.currentTokenIa, 'intent');
      }
    }
  }

  render() {
    const { monitore } = this.state;
    const {
      samples,
      bot,
      iaInfo,
      entities,
      curation,
      trainLuis,
      getIaInfo,
      user,
    } = this.props;

    const IaPlatform =
      bot && bot.ia && bot.ia.platforms.find((element) => element.isActive);

    const mediaSinonimos = () => {
      if (entities.length === 0) return 0;

      const quantitySynonyms = entities.reduce((accumulator, element) => {
        return (
          accumulator +
          element.objects.reduce((count, item) => {
            return count + item.synonyms.length;
          }, 0)
        );
      }, 0);

      const quantityObjects = entities.reduce((accumulator, element) => {
        return accumulator + element.objects.length;
      }, 0);

      if (quantityObjects === 0) return 0;

      return Math.round(quantitySynonyms / quantityObjects);
    };

    return (
      <div>
        {monitore === 'provedor' && (
          <Provedores
            getIaInfo={getIaInfo}
            bot={bot}
            platform={IaPlatform ? IaPlatform.platform : ''}
          />
        )}

        {monitore === 'status' && (
          <div className="container-status">
            <div className="container-modal-monitore">
              <div className="modal-status-monitore">
                <div className="modal-title-monitore">
                  <p className="title-monitore">Monitore sua IA</p>
                  <Toggle
                    className="no-margin bot-header-toggle"
                    disabled={
                      !!(user?.selectedCompany?.claim?.name === 'Viewer')
                    }
                    checked={bot.iaEnabled}
                    label={bot.iaEnabled ? 'IA Online' : 'IA Offline'}
                    onChange={this.onToggleChanged}
                  />
                </div>
                <div className="container-name-monitore">
                  {IaPlatform && IaPlatform.platform === 'luis' ? (
                    <span>
                      {bot.iaEnabled && iaInfo.status === 'done' ? (
                        <img
                          alt="iconCheck"
                          className="icon-check-style"
                          src={iconCheck}
                        />
                      ) : (
                        <img
                          alt="iconFalta"
                          className="icon-falta-style"
                          src={iconFalta}
                        />
                      )}
                      Status de Treinamento
                      <span style={{ marginLeft: '10px' }}>
                        (
                        {bot.iaEnabled &&
                        iaInfo.extra &&
                        iaInfo.extra.version &&
                        iaInfo.extra.version.lastPublishedDateTime !== null
                          ? moment(
                              iaInfo.extra.version.lastPublishedDateTime
                            ).format('DD/MM/YYYY HH:mm')
                          : '--/--/---- --:--'}
                        )
                      </span>
                    </span>
                  ) : (
                    <span>
                      {bot.iaEnabled &&
                      iaInfo.extra &&
                      iaInfo.extra.training_status === 'done' ? (
                        <img
                          alt="iconCheck"
                          className="icon-check-style"
                          src={iconCheck}
                        />
                      ) : (
                        <img
                          alt="iconFalta"
                          className="icon-falta-style"
                          src={iconFalta}
                        />
                      )}
                      Status de Treinamento
                      <span style={{ marginLeft: '10px' }}>
                        (
                        {bot.iaEnabled &&
                        iaInfo.extra &&
                        iaInfo.extra.will_train_at !==
                          '1969-12-31T16:00:00-0800'
                          ? moment(iaInfo.extra.will_train_at).format(
                              'DD/MM/YYYY HH:mm'
                            )
                          : '--/--/---- --:--'}
                        )
                      </span>
                    </span>
                  )}
                </div>
                <div className="container-name-monitore">
                  {bot.iaEnabled &&
                  bot.ia &&
                  bot.ia.platforms &&
                  bot.ia.platforms.length !== 0 ? (
                    <img
                      alt="iconCheck"
                      className="icon-check-style"
                      src={iconCheck}
                    />
                  ) : (
                    <img
                      alt="iconFalta"
                      className="icon-falta-style"
                      src={iconFalta}
                    />
                  )}
                  <span>
                    {bot.ia && bot.ia.platforms && bot.ia.platforms.length !== 0
                      ? 'Provedor de IA conectado'
                      : 'Provedor de IA não conectado'}
                    <button
                      disabled={user?.selectedCompany?.claim?.name === 'Viewer'}
                      onClick={() => this.isMonitore('provedor')}
                      data-tip="Veja as opções de provedores disponíveis."
                      data-for="alterButton"
                    >
                      alterar
                    </button>
                    <HelpBalloon id="alterButton" noImage />
                  </span>
                </div>
                <div className="container-name-monitore">
                  {bot.iaEnabled ? (
                    samples.length !== 0 ? (
                      <img
                        alt="iconCheck"
                        className="icon-check-style"
                        src={iconCheck}
                      />
                    ) : (
                      <img
                        alt="iconErro"
                        className="icon-erro-style"
                        src={iconErro}
                      />
                    )
                  ) : (
                    <img
                      alt="iconFalta"
                      className="icon-falta-style"
                      src={iconFalta}
                    />
                  )}
                  <span>
                    {bot.iaEnabled && samples.length !== 0
                      ? 'Intenções Criadas'
                      : 'Intenções Ausentes'}
                  </span>
                </div>
                <div className="container-name-monitore">
                  {bot.iaEnabled ? (
                    entities.length !== 0 ? (
                      <img
                        alt="iconCheck"
                        className="icon-check-style"
                        src={iconCheck}
                      />
                    ) : (
                      <img
                        alt="iconErro"
                        className="icon-erro-style"
                        src={iconErro}
                      />
                    )
                  ) : (
                    <img
                      alt="iconFalta"
                      className="icon-falta-style"
                      src={iconFalta}
                    />
                  )}
                  <span>
                    {bot.iaEnabled && entities.length !== 0
                      ? 'Entidades Criadas'
                      : 'Entidades Ausentes'}
                  </span>
                </div>
                <div className="container-name-monitore">
                  {bot.iaEnabled &&
                  curation.messages &&
                  curation.messages.length === 0 ? (
                    <img
                      alt="iconCheck"
                      className="icon-check-style"
                      src={iconCheck}
                    />
                  ) : (
                    <img
                      alt="iconFalta"
                      className="icon-falta-style"
                      src={iconFalta}
                    />
                  )}
                  <span>
                    {bot.iaEnabled &&
                    curation.messages &&
                    curation.messages.length !== 0
                      ? 'Aprimoramento Pendente'
                      : 'Sem Aprimoramento Pendente'}
                  </span>
                </div>
              </div>
              <div className="modal-int-monitore">
                <div className="container-part-1">
                  <div className="title-int-monitore">
                    <p className="number-monitore">
                      {bot.iaEnabled ? samples.length : 0}
                    </p>
                    <p className="subtitle-monitore">Intenções Cadastrada</p>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <CirclePoint item={bot.iaEnabled ? samples.length : 0} />
                    <p className="exemplos-monitore">
                      {bot.iaEnabled ? samples.length : 0} exemplos em média
                    </p>
                    <p className="text-bot-monitore">
                      Considere criar novos exemplos para o bot se comunicar com
                      mais facilidade com seu usuário.
                    </p>
                  </div>
                </div>
                <div className="line-modal" />

                <div className="container-part-2">
                  <div className="title-int-monitore">
                    <p className="number-monitore">
                      {bot.iaEnabled ? entities.length : 0}
                    </p>
                    <p className="subtitle-monitore">Entidades cadastradas</p>
                  </div>
                  <p className="sinonimos-monitore">
                    {bot.iaEnabled ? mediaSinonimos() : 0} Sinônimos em média
                  </p>
                </div>
              </div>
            </div>
            {IaPlatform && IaPlatform.platform === 'luis' ? (
              <div className="modal-publique">
                <p>Está satisfeito? Então</p>
                <button
                  disabled={bot.iaEnabled ? null : 'disabled'}
                  onClick={() => trainLuis(bot.currentTokenIa)}
                >
                  publique a IA
                </button>
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ia: state.intelligence.ia,
  samples: state.intelligence.samples,
  entities: state.intelligence.entities,
  bot: state.bots.bot,
  curation: state.intelligence.curation,
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...IaCreators,
      ...BotsCreators,
      ...UserActions,
    },
    dispatch
  );

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(memo(Monitore)))
);
